import React from 'react'
import { Dimmer, Loader, Image, Segment } from 'semantic-ui-react'

const Preloader = (props) => (
  <div className="h-100">
    <Segment className="h-100">
      <Dimmer active inverted>
        <Loader inverted>{props.message || 'Loading'}</Loader>
      </Dimmer>
      <Image src='./short-paragraph.png' />
    </Segment>
  </div>
)

export default Preloader;